import { Pipe, PipeTransform } from '@angular/core';
import { UrlSasDTO } from '../models/AzureStorage/UrlSasDTO';
import { ImageCacheService } from '../services/ImageCache.service';

@Pipe({
  name: 'replaceIconPanel'
})
export class ReplaceIconPanel implements PipeTransform {
  constructor() {}

  transform(icon: string): string {
    if (!icon) return icon;
    return icon.replace(".png", "P.png");
  }
}